import { Form, Input } from "antd"
import PropTypes from "prop-types"

SearchFieldPrimary.propTypes = {
  style: PropTypes.object,
  onSearch: PropTypes.func,
  initialSearch: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func
}

/**
 * @param {object} props
 * @param {object} props.style
 * @param {function} props.onSearch
 * @param {string} props.initialSearch
 * @param {string} props.value This is an optional prop in case you need to make it a controlled component
 * @param {function} props.onChange This is an optional prop in case you need to make it a controlled component
 */
export function SearchFieldPrimary({ style, onSearch = null, initialSearch, value }) {
  return (
    <Form style={{ ...style }}>
      <Input.Search
        allowClear
        value={value}
        defaultValue={initialSearch}
        placeholder="Buscar"
        onSearch={onSearch}
        enterButton />
    </Form>
  )
}
